// extracted by mini-css-extract-plugin
export var nav = "simple-nav-module--nav--3Dofd";
export var logo = "simple-nav-module--logo--1-5o2";